const METERS_PER_DEGREE_LAT = 111320;

/** Normalize a bearing to [0, 360). */
export function normalizeBearing(bearing) {
  return ((bearing % 360) + 360) % 360;
}

/** Smallest absolute difference between two bearings, in [0, 180]. */
export function bearingDifference(a, b) {
  const diff = Math.abs(normalizeBearing(a) - normalizeBearing(b));
  return diff > 180 ? 360 - diff : diff;
}

/** Signed rotation from bearing `from` to bearing `to`, in [-180, 180); positive = clockwise. */
export function signedBearingDifference(from, to) {
  return ((normalizeBearing(to) - normalizeBearing(from) + 540) % 360) - 180;
}

/** Axis-aligned bbox [minX, minY, maxX, maxY] of `meters` around a lon/lat point. */
export function bboxAround([lon, lat], meters) {
  const dLat = meters / METERS_PER_DEGREE_LAT;
  const dLon = meters / (METERS_PER_DEGREE_LAT * Math.max(Math.cos((lat * Math.PI) / 180), 1e-6));
  return [lon - dLon, lat - dLat, lon + dLon, lat + dLat];
}

export function coordKey([lon, lat]) {
  return `${lon.toFixed(6)},${lat.toFixed(6)}`;
}

export function sameCoord(a, b) {
  return coordKey(a) === coordKey(b);
}
